export default __webpack_public_path__ + "822feed1a8ffaec2cda62839dd197d47.png";